import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      const fr = this.props.language === 'fr';
      return (
        <div className="min-h-screen bg-[#FAFAF9] flex items-center justify-center px-4">
          <div className="text-center max-w-md">
            <div className="w-16 h-16 rounded-full bg-[#FF6B6B]/10 flex items-center justify-center mx-auto mb-4">
              <span className="text-2xl">!</span>
            </div>
            <h2 className="font-serif text-xl font-semibold text-stone-900 mb-2">
              {fr ? 'Une erreur est survenue' : 'Something went wrong'}
            </h2>
            <p className="text-stone-500 text-sm mb-6">
              {fr
                ? 'Essaie de vider le cache de ton navigateur ou de recharger la page.'
                : 'Try clearing your browser cache or reloading the page.'}
            </p>
            <div className="flex gap-3 justify-center">
              <button
                onClick={() => {
                  if ('caches' in window) {
                    caches.keys().then(names => names.forEach(name => caches.delete(name)));
                  }
                  window.location.reload();
                }}
                className="px-4 py-2 bg-[#FF6B6B] text-white rounded-xl text-sm font-medium hover:bg-[#EE5253] transition-colors"
              >
                {fr ? 'Recharger (vider le cache)' : 'Reload (clear cache)'}
              </button>
              <button
                onClick={() => window.location.href = '/dashboard'}
                className="px-4 py-2 bg-stone-100 text-stone-700 rounded-xl text-sm font-medium hover:bg-stone-200 transition-colors"
              >
                {fr ? 'Retour au dashboard' : 'Back to dashboard'}
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
